import { getBookingByUid } from '../../data/bookings';
import { getProductById } from '../../data/products';
import { logger } from '@/utils/logger';

/**
 * Extracts booking duration from database
 * Determines if it's a preparation or shooting booking and returns the correct duration
 */
export async function getBookingDuration(bookingUid: string): Promise<{
  durationMinutes: number;
  isPreparation: boolean;
}> {
  const bookingResult = await getBookingByUid(bookingUid);
  
  let durationMinutes = 180;
  let isPreparation = false;
  
  if (bookingResult.success && bookingResult.data?.product_id) {
    const currentBooking = bookingResult.data;
    
    isPreparation = currentBooking.event_type_slug?.toLowerCase().includes('pbm') || 
                   currentBooking.event_type_slug?.toLowerCase().includes('prep');
    
    const product = await getProductById(currentBooking.product_id);
    
    if (product) {
      durationMinutes = isPreparation 
        ? (product.preparation_duration_minutes || 45)
        : (product.shooting_duration_minutes || 180);
    }
  }
  
  logger.debug('Booking duration extracted', { bookingUid, durationMinutes, isPreparation });
  
  return { durationMinutes, isPreparation };
}

